import { useState } from "react";
import { auth, db } from "../firebase/config";
import { signInWithEmailAndPassword } from "firebase/auth";
import {
  getDoc,
  doc,
  setDoc,
  addDoc,
  collection,
  serverTimestamp,
} from "firebase/firestore";
import { useAuthContext } from "./useAuthContext";
import { useNavigate } from "react-router-dom";

export function useLogin() {
  const [error, setError] = useState(null);
  const { dispatch } = useAuthContext();
  const navigate = useNavigate();

  const login = async (email, password) => {
    setError(null);

    let res = null;
    try {
      console.log(`Trying to log in with email: ${email}`);

      // Initial login attempt with provided email
      res = await signInWithEmailAndPassword(auth, email, password);

      if (res.user) {
        console.log(
          `Logged in with ${email}. Email verified status: ${res.user.emailVerified}`
        );
        console.log(`logged in user: ${res.user}`);
      } else {
        console.log(`No user returned for ${email}`);
      }
    } catch (e) {
      console.error(`Error logging in with ${email}: ${e.message}`);
    }

    // If email is not verified, or there's no result from the first attempt, try alternate emails
    if (!res || !res.user || !res.user.emailVerified) {
      let newEmail = null;

      if (newEmail) {
        try {
          console.log(`Trying alternate email: ${newEmail}`);
          res = await signInWithEmailAndPassword(auth, newEmail, password);

          if (res.user) {
            console.log(
              `Logged in with ${newEmail}. Email verified status: ${res.user.emailVerified}`
            );
          } else {
            console.log(`No user returned for alternate email ${newEmail}`);
          }
        } catch (e) {
          console.error(
            `Error logging in with alternate email ${newEmail}: ${e.message}`
          );
          setError(`Error: ${e.message}`);
          return; // If error occurs with alternate email, stop execution
        }
      }
    }

    // If the user is still not verified after all attempts, throw an error
    if (!res.user.emailVerified) {
      setError(
        "Please verify your email before logging in. You should have received an email with a verification link. (if not, check your spam folder)"
      );
      return;
    }

    dispatch({ type: "LOGIN", payload: res.user });

    // Navigate to the desired route after successful login and necessary operations
    navigate(`/jewelrydesigner`);
  };

  return { error, login };
}
